



































import { computed, defineComponent } from "@vue/composition-api";
import { Location } from "vue-router";
import { Notification, NotificationType } from "@scrile/api-provider/dist/api/NotificationsProvider";
import { ContentFeed } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import { $t } from "@/lib/i18nHelpers";
import { getProfileUrl } from "@/lib/urlHelpers";
import ContentFeedCover from "@/components/ContentFeedCover";
import NotificationItemView from "../../NotificationItemView.vue";

export default defineComponent({
  name: "NotificationPostReview",
  components: { NotificationItemView, ContentFeedCover },
  props: {
    notification: { type: Object as () => Notification, required: true },
    isUnreadNotification: { type: Boolean, default: false },
  },
  setup(props) {
    const isReply = computed(() => props.notification.type === NotificationType.POST_REVIEW_MENTIONED);
    const reviewText = computed(() =>
      props.notification.details.review ? props.notification.details.review.comment : $t("comment deleted")
    );
    const contentFeed = computed<ContentFeed | undefined>(() => {
      return props.notification.details.post;
    });
    const subjectUrl = computed<Location>(() => {
      if (contentFeed.value) {
        return getProfileUrl(contentFeed.value.user, { feedId: props.notification.details.postId });
      }
      return {};
    });
    return {
      reviewText,
      subjectUrl,
      contentFeed,
      isReply,
    };
  },
});
